import React from 'react';
import PropTypes from 'prop-types';
import EmptyStateImage from 'assets/no_products_found.svg';

const EmptyTableState = ({
  title = 'No Results Found',
  message = '',
  overlayIcon = /** @type {string|null} */ (null),
  button = /** @type {React.ReactElement|null} */ (null),
  dataTestId = 'empty-table-state',
  containerClassName = 'w-full h-full pt-52px pb-66px flex flex-col justify-center items-center',
  messageClassName = 'text-sm mb-4',
  imageWidth = 234,
  titleClassName = 'text-sm font-semibold mb-2'
}) => (
  <div data-testid={dataTestId} className={containerClassName}>
    <img
      width={imageWidth}
      src={overlayIcon ?? EmptyStateImage}
      alt="empty-state"
    />
    <p
      className={`${titleClassName} ${
        overlayIcon === '/static/media/noDocumentFound.e8c780e2.svg'
          ? 'mt-10'
          : null
      }`}
    >
      {title}
    </p>
    {message && (
      <p data-testid="empty-table-state-message" className={messageClassName}>
        {message}
      </p>
    )}
    {button}
  </div>
);

EmptyTableState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  overlayIcon: PropTypes.element,
  button: PropTypes.element,
  dataTestId: PropTypes.string,
  containerClassName: PropTypes.string,
  messageClassName: PropTypes.string,
  imageWidth: PropTypes.number,
  titleClassName: PropTypes.string
};

export default EmptyTableState;
